import { utils } from '@hh/global.js'

const { debounce } = utils

class HHFiltersWrapper extends HTMLElement {
  constructor() {
    super()
    this.filterData = []
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 1000)

    this.querySelector('form').addEventListener(
      'input',
      this.debouncedOnSubmit.bind(this)
    )

    this.querySelector('.js-sort-select').addEventListener(
      'change',
      this.debouncedOnSubmit.bind(this)
    )
    window.addEventListener('popstate', this.onHistoryChange.bind(this))

    this.bindActiveFacetButtonEvents()
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const formData = new FormData(event.target.closest('form'))
    const searchParams = new URLSearchParams(formData).toString()
    this.renderPage(searchParams, event)
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    this.toggleActiveFacets()
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString())
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || ''
    this.renderPage(searchParams, null, false)
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
      element.classList.toggle('disabled-link', disable)
    })
  }

  renderPage(searchParams, event, updateURLHash = true) {
    const url =
      `${window.location.pathname}?` +
      this.getSections()
        .map((section) => `sections[]=${section.section}`)
        .join('&') +
      `&${searchParams}`

    const filterDataUrl = (element) => element.url === url

    this.filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl, event)
      : this.renderSectionFromFetch(url, event)

    if (updateURLHash) this.updateURLHash(searchParams)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.filterData = [...this.filterData, { html, url }]
        this.rerenderElement('.js-product-count', html)
        this.rerenderElement('.js-filter-count', html)
        this.rerenderElement('.js-product-grid-list', html)
        this.rerenderElement('.js-collection-load-more', html)
        this.rerenderElement('.js-load-more-container', html)
        this.rerenderElement('.js-filter-drawer-header', html)
        this.rerenderElement('.js-filter-drawer-footer', html)
        this.renderFilters(html, event)
      })
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html
    this.rerenderElement('.js-product-count', html)
    this.rerenderElement('.js-filter-count', html)
    this.rerenderElement('.js-product-grid-list', html)
    this.rerenderElement('.js-collection-load-more', html)
    this.rerenderElement('.js-load-more-container', html)
    this.rerenderElement('.js-filter-drawer-header', html)
    this.rerenderElement('.js-filter-drawer-footer', html)
    this.renderFilters(html, event)
  }

  rerenderElement(className, html) {
    const data = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(className).innerHTML

    const prevEls = document.querySelectorAll(className)
    prevEls.forEach((el) => (el.innerHTML = data))
  }

  renderFilters(...args) {
    this.renderSingleFormFilters('#CollectionFiltersForm', ...args)

    document.dispatchEvent(
      new CustomEvent('plp:filter-update', {
        bubbles: true,
        composed: true,
      })
    )
  }

  renderSingleFormFilters(form, html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetDetailsElements = parsedHTML.querySelectorAll(
      `${form} .js-filter`
    )
    const matchesIndex = (element) =>
      element.dataset.index ===
      event?.target.closest('.js-filter')?.dataset.index

    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    )

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

    facetsToRender.forEach((element) => {
      document.querySelector(
        `${form} .js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML
    })

    this.renderActiveFacets(parsedHTML)

    if (countsToRender) {
      this.renderCounts(countsToRender, event.target.closest('.js-filter'))
    }
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.js-facets--mobile',
      '.js-facets--desktop',
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    this.bindActiveFacetButtonEvents()
  }

  renderCounts(source, target) {
    const countElementSelectors = ['.js-bubble', '.js-selected']
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector)
      const sourceElement = source.querySelector(selector)

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML =
          source.querySelector(selector).outerHTML
      }
    })
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, {
        once: true,
      })
    })
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  getSections() {
    return [
      {
        id: 'main-collection-filters',
        section: document.getElementById('main-collection-filters').dataset.id,
      },
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('CollectionProductGrid').dataset.id,
      },
    ]
  }
}

customElements.define('hh-filters-wrapper', HHFiltersWrapper)
